import { observable,action } from "mobx";
import { isDataExist } from "Utils/dataTools";
import * as services from '../services/pending';
import {message} from 'antd'
class Pending{
    @observable tableData=[]; //列表数据
    @observable supplierData=[]; //供应商数据
    @observable clientData=[]; //供应商数据
    @observable materialData=[]; //物料名称数据
    @observable pageInfo={pageIndex:1,pageSize:10}; //页面数据分页
    @observable handleId=''; //处理页面提交的Id
    @observable visible=false; //处理页面提交的Id
    @observable planNo=''; //生产计划号查询
    @observable orderNo=''; //订单号查询
    @observable supplierId='' //供应商的查询
    @observable clientName='' //客户名称的查询
    // @observable clientId=''
    @observable orderColor='' //颜色的查询
    @observable materialId='' //物料的搜索
    @observable status='' //计划状态的搜索
    @observable handleStatus=1
    @observable startTimeForDeadline='' //开始时间的查询
    @observable endTimeForDeadline=''   //结束时间的查询
    @observable materialName=''  //通过名称查询物料
@action.bound async getProductList(params){
    try{
   let res=await services.gets('productList')({
    ...params,
    ...this.pageInfo,
   })
   if(isDataExist(res)){
 this.tableData=res.data.data.items
 this.pageInfo=res.data.data.page
   }
    }catch(error){
        console.log(error)
    }
}

@action.bound async getSupplier(params){
    try{
    let res=await services.gets('getSupplier')(params)
    if(isDataExist(res)){
  this.supplierData=res.data.data
    }
    }catch(error){
        console.log(error)
    }
}

@action.bound async getClient(params){
    try{
    let res=await services.gets('getClient')(params)
    if(isDataExist(res)){
  this.clientData=res.data.data
    }
    }catch(error){
        console.log(error)
    }
}

@action.bound async getMaterial(params){
    try{
let res=await services.gets('getInfo')(params)
 if(isDataExist(res)){
     this.materialData=res.data.data
 }
    }catch(error){
        console.log(error)
    }
}

@action.bound async getSaveToHandle(params){
    try{
   let res=await services.posts('saveToHandle')(params)
   if(isDataExist(res)){
    message.success('处理成功')
   }
    }catch(error){
        console.log(error)
    }
}

@action clearData(){
this.tableData=[];
this.supplierData=[];
this.clientData=[];
this.materialData=[];
this.pageInfo={pageIndex:1,pageSize:10};
this.handleId='';
this.visible=false;
this.planNo='';
this.orderNo='';
this.supplierId='';
this.clientName='';
this.orderColor='';
this.materialId='';
this.status='';
this.handleStatus=1;
this.startTimeForDeadline='';
this.endTimeForDeadline='';
this.materialName='';
// this.clientId=''
}

}
let PendingStore=new Pending();
export default PendingStore